<template>
  <div>
    <FormItem v-bind="itemProp">
    <draggable :value="value" @input="onDrag" @start="drag=true" @end="drag=false">
      <branch-tip
        v-for="(out, index) in value"
        :key="index"
        :conditions="out.conditions"
        :disabled="drag"
      >
        <Tag
          v-if="out.intent_id !== '_miss'"
          size="medium"
          :color="out.intent_id === '_knowledge' ? 'warning' : 'primary'"
          closable
          @on-close="delOuts(out.intent_id)"
        >
          <span style="cursor: pointer;" @click="onEdit(index)">{{ intentsMap[out.intent_id] && intentsMap[out.intent_id].name }}</span>
        </Tag>
      </branch-tip>
      </draggable>
      <Button shape="circle" type="warning" @click="showAddBranch">增加出口</Button>
    </FormItem>
    <add-branch v-if="addBranch" :ignore="outIds" v-model="showBranchModal" :curBranch="value[curBranchIndex]" @addBranch="editOut" />
  </div>

</template>

<script>
import { mapGetters } from 'vuex';
import BranchTip from './BranchTip.vue';
import draggable from 'vuedraggable'

export default {
  components: {
    BranchTip,
    draggable,
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    formItemProps: {
      type: Object,
      default: () => ({})
    },
  },
  data() {
    return {
      showBranchModal: false,
      curBranchIndex: undefined,
      drag: false,
      addBranch: null,
    };
  },
  watch: {
    showBranchModal(val) {
      if (!val) {
        this.curBranchIndex = undefined
      }
    }
  },
  computed: {
    ...mapGetters('intents', ['intentsMap']),
    itemProp() {
      return {
        label: '出口',
        ...this.formItemProps,
      }
    },
    outIds() {
      return this.value.map(item => item.intent_id)
    }
  },
  methods: {
    showAddBranch() {
      this.showBranchModal = true;
    },
    onEdit(index) {
      this.curBranchIndex = index;
      this.showAddBranch();
    },
    // 添加 / 编辑分支
    editOut({ intentId, conditions, vars, force_break }) {
      if (this.curBranchIndex === undefined) {
        this.$emit('change', [...this.value, { intent_id: intentId, conditions, vars, force_break }])
      } else {
        this.value.splice(this.curBranchIndex, 1, { ...this.value[this.curBranchIndex], intent_id: intentId, conditions, vars, force_break })
        this.$emit('change', [...this.value])
      }
    },
		// 删除分支
    delOuts(intentId) {
      const intentIndex = this.value?.findIndex(
        (item) => item.intent_id === intentId
      );
      if (~intentIndex) {
        this.value.splice(intentIndex, 1);
      }
    },
    onDrag(value) {
      this.$emit('change', value)
    },
    loadComponent() {
      this.addBranch = true;
      if (!this.$options.components.AddBranch) {
        this.$options.components.AddBranch = () => import('./AddBranch.vue');
      }
    }
  },
  mounted() {
    this.loadComponent()
  },
}
</script>